import React, { useEffect, useState } from "react";
import PageTitle from "../../Components/layouts/header/page-title";
import FilterSideBar from "../../Components/UI/FilterSideBar";
import HeaderFilter from "./widgets/HeaderFilter";
import SwapListing from "./widgets/SwapListing";
import SwapProposals from "./widgets/SwapProposals";
import { getSpecificEmployeeDataForMonth } from "../../services/schedule.service";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { getSwapRequest, cancelSwapRequest, getSwapProposals } from "../../services/request.service";
import {
  requestsSelector,
  setRequests,
} from "../../features/Request/requestSlice";
import moment from "moment";

type MenuItemData = any;

export interface ShiftDayDetails {
  date: string; // ISO date string
  day: string; // Name of the day
  dayNumber: number; // Day of the month
  isDayBalanced: boolean; // Day shift balance status
  isDayOverUtilization: boolean; // Day shift over utilization status
  isDayShift: boolean; // Whether it's a day shift
  isNightBalanced: boolean; // Night shift balance status
  isNightOverUtilization: boolean; // Night shift over utilization status
  isNightShift: boolean; // Whether it's a night shift
  isOnLeave: boolean; // Leave status
  isOnTimeOff: boolean; // Time off status
  leaveType: string; // Type of leave if applicable
}

interface IEmployeeInfo {
  _id: string;
  firstName: string;
  lastName: string;
}

interface IBranchInfo {
  _id: string;
}

export interface ISwapRequestResponse {
  _id: string;
  employee: IEmployeeInfo;
  branch: IBranchInfo;
  day: number;
  month: number;
  year: number;
  shift: "day" | "night"; // assuming these are the only possible values
  active: boolean;
  createdAt: string; // or Date if you're parsing it
}

const Swap = () => {
  const nextMonth = moment().add(1, "month");
  const [month, setMonth] = useState(+nextMonth.format("M"));
  const [year, setYear] = useState(+nextMonth.format("YYYY"));
  const [shifts, setShifts] = useState<ShiftDayDetails[]>([]);
  const [outgoingProposals, setOutgoingProposals] = useState<any[]>([]);
  const [allProposals, setAllProposals] = useState<any[]>([]);
  const dispatch = useDispatch();
  const requests = useSelector(requestsSelector);
  const { User } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    fetchMonthlySchedule();
    fetchSwapRequests();
    fetchOutgoingProposals();
  }, [month, year]);

  const fetchSwapRequests = async () => {
    const res: any = await getSwapRequest();
    if (res?.res) {
      dispatch(setRequests(res.res.data as ISwapRequestResponse[]));
    }
  };

  const fetchOutgoingProposals = async () => {
    const res: any = await getSwapProposals();
    if (res?.res?.data) {
      const all: any[] = res.res.data;
      const outgoing = all.filter(
        (p: any) => p.requester?._id === User?.id || p.requester === User?.id
      );
      setOutgoingProposals(outgoing);
      // Pass all proposals so SwapListing can render a history section
      setAllProposals(all);
    }
  };

  const handleCancelRequest = async (id: string) => {
    await cancelSwapRequest(id);
    fetchSwapRequests();
  };

  const fetchMonthlySchedule = async () => {
    const res: any = await getSpecificEmployeeDataForMonth(month, year);
    if (res?.res?.employeeInfo) {
      setShifts(res.res.employeeInfo.shifts);
    }
  };

  return (
    <div className="bg-[#f8f8f8]">
      <PageTitle
        title="Swap"
        subtitle="List of all your requested duty swaps"
      />
      <div className="flex flex-wrap">
        <div className="w-full">
          <div className="p-[20px_30px]">
            <HeaderFilter shifts={shifts} month={month} year={year} />
          </div>
          <div className="swaplisting p-[0_20px_30px] h-[calc(100vh-280px)] overflow-y-auto">
            <SwapProposals onUpdate={fetchOutgoingProposals} />
            <SwapListing requests={requests} outgoingProposals={outgoingProposals} allProposals={allProposals} myId={User?.id} onCancel={handleCancelRequest} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Swap;
